/* eslint-disable */
export default {
  all: '全部',
  company: '公司',
  personal: '个人',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
